import {ReactElement} from 'react';
import Heading, {HEADING_TYPES} from '@frontend/ui-kit/Components/Heading';
import Benefits from './Benefits';
import Feedbacks from './Feedbacks';
import Footer from './Footer';
import {gettext} from '../../translationService';
import './index.scss';

const ProductInfo = (): ReactElement => {
    return (
        <div className='product-info'>
            <div className='product-info-layout'>
                <Heading type={HEADING_TYPES['2']} className='product-info-title'>
                    {gettext('What can you do with HealthJoy?')}
                </Heading>

                <Benefits/>

                <Feedbacks/>

                <Footer/>
            </div>
        </div>
    );
};

export {ProductInfo as TestableProductInfo};
export default ProductInfo;
